// Lets the testers' insights panel watch the tracker. With no listener, emit() returns at once.
const listeners = new Set()

export function subscribe(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function emit(type, detail) {
  if (listeners.size === 0) return
  listeners.forEach((listener) => {
    try {
      listener(type, detail)
    } catch (err) {
      // A broken listener must never break tracking.
    }
  })
}
